

import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";
import GenericChartComponent from "./GenericChartComponent";

import { isDefined, functor } from "./utils";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";


function displayValuesFor(props, moreProps) {
	const { currentItem } = moreProps;
	return currentItem;
}

class OHLCTooltip extends Component {
	constructor(props) {
		super(props);
		this.renderSVG = this.renderSVG.bind(this);
	}
	renderSVG(moreProps) {
		const { displayValuesFor } = this.props;
		const {
			xDisplayFormat,
			accessor,
			volumeFormat,
			ohlcFormat,
			percentFormat,
			displayTexts
		} = this.props;

		const { chartConfig: { width, height } } = moreProps;
		const { displayXAccessor } = moreProps;

		const currentItem = displayValuesFor(this.props, moreProps);

		let displayDate, open, high, low, close, volume, percent, adx, rsi, macd, roc5, roc20, bbw;
		displayDate = open = high = low = close = volume = percent = adx = rsi = macd = roc5 = roc20 = bbw = displayTexts.na;

		if (isDefined(currentItem) && isDefined(accessor(currentItem))) {
			const item = accessor(currentItem);
			volume = isDefined(item.volume) ? volumeFormat(item.volume) : displayTexts.na;
			displayDate = xDisplayFormat(displayXAccessor(item));
			open = ohlcFormat(item.open);
			high = ohlcFormat(item.high);
			low = ohlcFormat(item.low);
			close = ohlcFormat(item.close);
            adx = ohlcFormat(item.adx);
            rsi = ohlcFormat(item.rsi);
            macd = ohlcFormat(item.macd);
            roc5 = ohlcFormat(item.roc5);
            roc20 = ohlcFormat(item.roc20);
            bbw = ohlcFormat(item.bbw);

			percent = percentFormat((item.close - item.open) / item.open);
		}

		const { origin: originProp } = this.props;
		const origin = functor(originProp);
		const [x, y] = origin(width, height);

		const itemsToDisplay = {
			displayDate,
			open,
			high,
			low,
			close,
			percent,
			volume,
            adx,
            rsi,
            macd,
            roc5,
            roc20,
            bbw,
			x,
			y
		};
		return this.props.children(this.props, moreProps, itemsToDisplay);
	}
	render() {
		return (
			<GenericChartComponent
				clip={false}
				svgDraw={this.renderSVG}
				drawOn={["mousemove"]}
			/>
		);
	}
}

OHLCTooltip.propTypes = {
	className: PropTypes.string,
	accessor: PropTypes.func,
	xDisplayFormat: PropTypes.func,
	children: PropTypes.func,
	volumeFormat: PropTypes.func,
	percentFormat: PropTypes.func,
	ohlcFormat: PropTypes.func,
	origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
	fontFamily: PropTypes.string,
	fontSize: PropTypes.number,
	onClick: PropTypes.func,
	displayValuesFor: PropTypes.func,
	textFill: PropTypes.string,
	labelFill: PropTypes.string,
	displayTexts: PropTypes.object,
};

const displayTextsDefault = {
	d: "Date: ",
	o: " O: ",
	h: " H: ",
	l: " L: ",
	c: " C: ",
	v: " Vol: ",
    r: " Rsi: ",
    m: " Macd: ",
    r2: " Roc20: ",
    r5: " Roc5: ",
    b: " Bbw: ",
    a: " Adx: ",
	na: "n/a"
};

OHLCTooltip.defaultProps = {
	accessor: d => {
		return {
			date: d.date,
			open: d.open,
			high: d.high,
			low: d.low,
            adx: d.adx,
            rsi: d.rsi,
            macd: d.macd.macd,
            roc5: d.roc5,
            roc20: d.roc20,
            bbw: d.bb_width,
			close: d.close,
			volume: d.volume
		};
	},
	xDisplayFormat: timeFormat("%Y-%m-%d"),
	volumeFormat: format(".4s"),
	percentFormat: format(".2%"),
	ohlcFormat: format(".2f"),
	displayValuesFor: displayValuesFor,
	origin: [0, 0],
	children: defaultDisplay,
	displayTexts: displayTextsDefault,
};

function defaultDisplay(props, moreProps, itemsToDisplay) {

	/* eslint-disable */
	const {
		className,
		textFill,
		labelFill,
		onClick,
		fontFamily,
		fontSize,
		displayTexts
	} = props;
	/* eslint-enable */

	const {
		displayDate,
		open,
		high,
		low,
		close,
		volume,
        adx,
        rsi,
        macd,
        roc5,
        roc20,
        bbw,
		x,
		y
	} = itemsToDisplay;
	return (
		<g
			className={`react-stockcharts-tooltip-hover ${className}`}
			transform={`translate(${x}, ${y})`}
			onClick={onClick}
		>
			<ToolTipText
				x={0}
				y={0}
				fontFamily={fontFamily}
				fontSize={fontSize}
			>
				<ToolTipTSpanLabel
					fill={labelFill}
					key="label"
					x={0}
					dy="5">{displayTexts.d}</ToolTipTSpanLabel>
				<tspan key="value" fill={textFill}>{displayDate}</tspan>
				<ToolTipTSpanLabel fill={labelFill} key="label_O">{displayTexts.o}</ToolTipTSpanLabel>
				<tspan key="value_O" fill={textFill}>{open}</tspan>
				<ToolTipTSpanLabel fill={labelFill} key="label_H">{displayTexts.h}</ToolTipTSpanLabel>
				<tspan key="value_H" fill={textFill}>{high}</tspan>
				<ToolTipTSpanLabel fill={labelFill} key="label_L">{displayTexts.l}</ToolTipTSpanLabel>
				<tspan key="value_L" fill={textFill}>{low}</tspan>
				<ToolTipTSpanLabel fill={labelFill} key="label_C">{displayTexts.c}</ToolTipTSpanLabel>
				<tspan key="value_C" fill={textFill}>{close}</tspan>
				<ToolTipTSpanLabel fill={labelFill} key="label_Vol">{displayTexts.v}</ToolTipTSpanLabel>
				<tspan key="value_Vol" fill={textFill}>{volume}</tspan>
			</ToolTipText>
            <ToolTipText
				x={0}
				y={25}
				fontFamily={fontFamily}
				fontSize={fontSize}
			>
                <ToolTipTSpanLabel fill={labelFill} key="label_Rsi">{displayTexts.r}</ToolTipTSpanLabel>
				<tspan key="value_Rsi" fill={textFill}>{rsi}</tspan>
                <ToolTipTSpanLabel fill={labelFill} key="label_Macd">{displayTexts.m}</ToolTipTSpanLabel>
				<tspan key="value_Macd" fill={textFill}>{macd}</tspan>
                <ToolTipTSpanLabel fill={labelFill} key="label_Adx">{displayTexts.a}</ToolTipTSpanLabel>
				<tspan key="value_Adx" fill={textFill}>{adx}</tspan>
                <ToolTipTSpanLabel fill={labelFill} key="label_R5">{displayTexts.r5}</ToolTipTSpanLabel>
				<tspan key="value_R5" fill={textFill}>{roc5}</tspan>
                <ToolTipTSpanLabel fill={labelFill} key="label_R20">{displayTexts.r2}</ToolTipTSpanLabel>
				<tspan key="value_R20" fill={textFill}>{roc20}</tspan>
                <ToolTipTSpanLabel fill={labelFill} key="label_BBW">{displayTexts.b}</ToolTipTSpanLabel>
				<tspan key="value_BBW" fill={textFill}>{bbw}</tspan>
			</ToolTipText>
		</g>
	);
}

export default OHLCTooltip;